<template>
  <VaLayout class="h-screen flex flex-row items-center justify-center">
    <template #content>
      <main class="bg-white flex flex-row items-center justify-center mx-6 shadow-2xl rounded-xl p-6">
        <div class="flex flex-col items-center">
          <RouterLink class="py-4" to="/" aria-label="Visit homepage">
            <h1 class="text-xl font-bold">Fast and Secure Access</h1>
          </RouterLink>
          <RouterView />
        </div>
      </main>
    </template>
  </VaLayout>
</template>
